/* -----------------Child components--------------- */
import type { Confidence } from "@memorang/types";
import BottomNavigationSession from "./BottomNavigationSession";
import NavButtons, {
	type NextButtonProps,
	type QuestionsConfig,
} from "./NavButtons";
import SubmitAnswer from "./SubmitAnswer";
import SubmitPteAssessorButton from "./SubmitPteAssessorButton";

interface Props extends NextButtonProps {
	showConfidenceSubmitButtons?: boolean;
	handleConfidenceProvided: (confidence: Confidence) => void;
	handleAiFeedbackProvided: (confidence: Confidence) => void;
	handleGenerateFeedback?: (callback: () => void) => Promise<void>;
	submitAnswerDynamicCta?: string;
	isSummativeTest?: boolean;
	toggleHelpDialog?: () => void;
	inReviewMode?: boolean;
	showSubmitAnswerAIFeedbackButton?: boolean;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
	questionsConfig?: QuestionsConfig;
	agentButton?: { onPress: () => void; disabled?: boolean; label?: string };
}
const StudySessionBottomAppBar = ({
	handleNext,
	handlePrevious,
	showConfidenceSubmitButtons,
	handleConfidenceProvided,
	isSummativeTest,
	toggleHelpDialog,
	inReviewMode,
	showSubmitAnswerAIFeedbackButton,
	handleAiFeedbackProvided,
	handleGenerateFeedback,
	handleTrackConfidenceClick,
	submitAnswerDynamicCta,
	buttonConfig,
	showPreviousButton,
	nextButtonState,
	questionsConfig,
	progressIndicator,
	aboutConfig,
	exitConfig,
	agentButton,
}: Props) => {
	return (
		<BottomNavigationSession
			isSummativeTest={isSummativeTest}
			inReviewMode={inReviewMode}
		>
			{agentButton ? (
				<SubmitPteAssessorButton
					onPress={agentButton.onPress}
					disabled={agentButton.disabled}
					label={agentButton.label || "Submit response"}
				/>
			) : showSubmitAnswerAIFeedbackButton || showConfidenceSubmitButtons ? (
				<SubmitAnswer
					type={showSubmitAnswerAIFeedbackButton ? "dynamic" : "static"}
					handleConfidenceProvided={handleConfidenceProvided}
					handleAiFeedbackProvided={handleAiFeedbackProvided}
					handleGenerateFeedback={handleGenerateFeedback}
					handleTrackConfidenceClick={handleTrackConfidenceClick}
					cta={submitAnswerDynamicCta || "Submit"}
				/>
			) : (
				<NavButtons
					showPreviousButton={showPreviousButton}
					nextButtonState={nextButtonState}
					buttonConfig={buttonConfig}
					handleNext={handleNext}
					handlePrevious={handlePrevious}
					isSummativeTest={isSummativeTest}
					inReviewMode={inReviewMode}
					toggleHelpDialog={toggleHelpDialog}
					questionsConfig={questionsConfig}
					progressIndicator={progressIndicator}
					aboutConfig={aboutConfig}
					exitConfig={exitConfig}
				/>
			)}
		</BottomNavigationSession>
	);
};

export default StudySessionBottomAppBar;
